"use strict";

var _toArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/toArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

function equal() {
  return {
    name: 'equal',
    synopsis: 'equal [VALUE1] [VALUE2] ...[VALUES]',
    description: 'Check two or more arguments for equality',
    options: {
      s: {
        alias: 'strict',
        description: 'Use strict equality (=== instead of ==)',
        type: 'boolean',
        default: false
      }
    },
    execute: function execute(_ref, opts) {
      var _ref2 = _toArray(_ref),
          first = _ref2[0],
          rest = _ref2.slice(1);

      var compare = opts.strict ? function (a, b) {
        return a === b;
      } : function (a, b) {
        return a == b;
      };
      return rest.every(function (value) {
        return compare(value, first);
      });
    }
  };
}

var _default = equal;
exports.default = _default;